import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "~/lib/utils";

// `dark:prose-invert` covers the elements not pinned to `text-foreground` — most
// visibly `code`, whose default near-black is unreadable on a dark surface.
export const PROSE_CLASSNAME =
  "prose prose-sm max-w-none dark:prose-invert prose-headings:font-semibold prose-headings:text-foreground prose-p:text-foreground prose-li:text-foreground prose-strong:text-foreground prose-em:text-foreground";

interface MarkdownPreviewProps {
  children: string;
  className?: string;
}

/**
 * Renders authored Markdown (descriptions, agent instructions, skills) as prose.
 * Assistant messages use the richer `Markdown` renderer instead — it adds math,
 * highlighted code blocks, and artifact refs that only mean something in a chat.
 */
export function MarkdownPreview({ children, className }: MarkdownPreviewProps) {
  return (
    <div className={cn(PROSE_CLASSNAME, className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
